
<template>
    <div class="mt-5">
        <h3>DevTools</h3>

        <h5 class="mt-5">LocalStorage</h5>
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">Key</th>
                    <th scope="col">Size</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(itm, idx) in localStorageSizes" :key="'localStorageSizes_' + idx">
                    <td>{{itm.key}}</td>
                    <td>{{itm.size}}</td>
                    <td><i v-if="itm.key == 'store'" class="far fa-copy" v-b-tooltip.hover :title="copyToPopupText" v-on:click="copyToClipboard(storeValue)"></i></td>
                </tr>
            </tbody>
        </table>

        <h5 class="mt-5">Store</h5>
        <table class="table">
            <thead>
                <tr>
                    <th scope="col">Key</th>
                    <th scope="col">Size</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>developerExceptions</td>
                    <td>{{developerExceptions ? developerExceptions.length : 0 }}</td>
                    <td><i v-if="developerExceptions" class="far fa-copy" v-b-tooltip.hover :title="copyToPopupText" v-on:click="copyToClipboard(JSON.stringify(developerExceptions))"></i>
                    <i class="far fa-trash-alt pl-2" v-b-tooltip.hover :title="deletePopupText" v-on:click="deleteDeveloperExceptions()"></i></td>
                </tr>
            </tbody>
        </table>

        <!--<div>
        <json-viewer v-model="storeValue"
                     :viewMode="0" />
    </div>-->
    </div>
</template>

<script>
    
    //import JsonViewer from '@/components/jsonViewer.vue'
    import { mapActions, mapGetters } from 'vuex'
    export default {
        name: 'DevTools',
        components: {
            //'json-viewer': JsonViewer
        },
        data: () => {
            return {
                localStorageSizes: [],
                localStorageTotal: null,
                storeValue: null,

                copyToPopupText: 'Copy to clipboard',
                deletePopupText: 'Delete'
            }
        },
        beforeMount() {
            this.getLocalStorageSize()
            this.getLocalStorageStore()
        },
        mounted() {
            
        },
        computed: {
            developerExceptions() {
                return this.$store.state.developerExceptions
            }
        },
        methods: {
            ...mapActions({
                resetExceptions: "resetDeveloperExceptions"
            }),
            getLocalStorageSize() {
                let { localStorageSizes, localStorageTotal } = this
                this.localStorageSizes = []
                this.localStorageTotal = 0

                var _lsTotal = 0,
                    _xLen, _x
                for (_x in localStorage) {
                    if (!localStorage.hasOwnProperty(_x)) {
                        continue;
                    }
                    _xLen = ((localStorage[_x].length + _x.length) * 2);
                    _lsTotal += _xLen;
                    this.localStorageSizes.push({ key: _x.substr(0, 50), size: (_xLen / 1024).toFixed(2) + " KB" })
                }
                this.localStorageTotal = (_lsTotal / 1024).toFixed(2) + " KB"
            },
            getLocalStorageStore() {
                this.storeValue = localStorage.getItem('store')
            },
            copyToClipboard(val) {

                var tempInput = document.createElement("input");
                tempInput.value = val;
                document.body.appendChild(tempInput);
                tempInput.select();
                try {
                    if (document.execCommand('copy')) {
                        this.copyToPopupText = 'Copied'
                        let self = this
                        setTimeout(function () {
                            self.copyToPopupText = 'Copy to clipboard'
                        }, 2000);
                    }

                } catch (err) {
                    console.log(err)
                }

                document.body.removeChild(tempInput);


            },
            deleteDeveloperExceptions() {
                this.deletePopupText = 'Deleted'
                this.resetExceptions()
                let self = this
                setTimeout(function () {
                    self.deletePopupText = 'Delete'
                }, 2000);
            }
        }
    }
</script>